import { useQuery } from '@tanstack/react-query';
import { ClientListItem } from 'src/admin/users/types';
import { api } from 'src/common/utils/api';

type UseClientsPaginatedFilters = {
  page?: number;
  size?: number;
  search?: string;
  advisorUserId?: string;
  familyId?: string;
  isTest?: boolean;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
};

type ClientsPaginatedQuery = {
  page: number;
  size: number;
  sortBy: string;
  sortDir: 'asc' | 'desc';
  search?: string;
  advisorUserId?: string;
  familyId?: string;
  isTest?: boolean;
};

const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_SORT_BY = 'name';
const DEFAULT_SORT_DIR: 'asc' | 'desc' = 'asc';

export const useClientsPaginated = (
  {
    page = 1,
    size = DEFAULT_PAGE_SIZE,
    search,
    advisorUserId,
    familyId,
    isTest,
    sortBy = DEFAULT_SORT_BY,
    sortDir = DEFAULT_SORT_DIR,
  }: UseClientsPaginatedFilters = {},
  { enabled }: { enabled?: boolean } = {},
) => {
  const params: ClientsPaginatedQuery = { page, size, sortBy, sortDir };
  if (search) params.search = search;
  if (advisorUserId) params.advisorUserId = advisorUserId;
  if (familyId) params.familyId = familyId;
  if (isTest !== undefined) params.isTest = isTest;

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['clients', params],
    queryFn: () => api.getPaginated<ClientListItem>('clients', params),
    enabled,
  });

  return {
    items: data?.items ?? [],
    total: data?.total ?? 0,
    isLoading,
    isError,
    refetch,
  };
};
